import React, {useEffect} from "react";
import {motion} from "framer-motion";

// Render a string value even if a raw message is an object.
const toText = (value) => {
  if (typeof value === "string") return value;
  if (value === undefined || value === null) return "";
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (typeof value === "object") {
    const candidate = value.message ?? value.err;
    if (candidate !== undefined && candidate !== null) return toText(candidate);
    return JSON.stringify(value);
  }
  return String(value);
};

const Toast = ({message, onClose, isSuccess = true}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(); // Hide after 5 seconds
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return isSuccess ? (
    <motion.div
      initial={{y: -50, opacity: 0}}
      animate={{y: 0, opacity: 1}}
      exit={{y: -50, opacity: 0}}
      className="toast-message"
    >
      {toText(message)}
    </motion.div>
  ) : (
    <motion.div
      initial={{y: -50, opacity: 0}}
      animate={{y: 0, opacity: 1}}
      exit={{y: -50, opacity: 0}}
      className="toast-message2"
    >
      {toText(message)}
    </motion.div>
  );
};

export default Toast;
